import { useState } from 'react'
import { SearchIcon } from '../../../../assets/svg'

const TABS = [
  { value: 'all', label: 'Все' },
  { value: 'active', label: 'Активные' },
  { value: 'completed', label: 'Завершенные' },
]

const Filters = () => {
  const [tab, setTab] = useState('all')
  const [query, setQuery] = useState('')

  return (
    <div className="mb-[1.25rem] flex flex-wrap items-center gap-[0.75rem] sm:gap-[1.25rem]">
      <label className="relative flex w-full sm:w-auto sm:min-w-[18rem] sm:flex-1 sm:max-w-[23rem] items-center">
        <span className="absolute left-[1rem] flex items-center">
          <SearchIcon />
        </span>
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Поиск по названию, месту..."
          className="w-full rounded-[10px] border border-solid border-[#d9d9d9] bg-white py-[0.625rem] sm:py-[0.75rem] pl-[2.75rem] pr-[1rem] text-[0.938rem] sm:text-[1rem] text-[#111827] outline-none placeholder:text-[#9ca3af] focus:border-[#0d9488]"
        />
      </label>

      <div className="flex flex-wrap gap-[0.25rem] rounded-[10px] border border-solid border-[#d9d9d9] bg-white p-[0.25rem]">
        {TABS.map(({ value, label }) => {
          const active = tab === value
          return (
            <button
              key={value}
              type="button"
              onClick={() => setTab(value)}
              className={`cursor-pointer rounded-[8px] border-0 px-[0.875rem] sm:px-[1.25rem] py-[0.5rem] text-[0.875rem] sm:text-[1rem] font-medium transition-colors ${
                active
                  ? 'bg-[#f3f4f6] text-[#111827]'
                  : 'bg-transparent text-[#6b7280] hover:text-[#111827]'
              }`}
            >
              {label}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default Filters
